<div fxFlex="100">
    <calsoft-xl-mapper [title]="'Lead Advance Xl'" guide="lead-xl-mapper" [enableSequences]="enableSequences" [type]="9"
        [serviceUrl]="'updateXl'" [urlNew]="'lead'">

    </calsoft-xl-mapper>
</div>